import "./DismissibleToast.css";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import { HiX } from "react-icons/hi";
import { FaCopy } from "react-icons/fa";

function DismissibleToast() {
  const MAX_MESSAGE_LENGTH = 500;

  const copyToClipboard = (message) => {
    navigator.clipboard.writeText(message.props.children).then(() => {
      toast.success("Copied to clipboard!", { autoClose: 2000 });
    });
  };

  const truncateMessage = (message) => {
    if (!message) return "";

    if (message.length > MAX_MESSAGE_LENGTH) {
      return message.substring(0, MAX_MESSAGE_LENGTH) + "...";
    } else {
      return message;
    }
  };

  return (
    <div id="dismissible-toast-container">
      <Toaster
        reverseOrder={false}
        position="top-center"
        toastOptions={{
          success: {
            duration: 5000,
          },
          error: {
            duration: 60000,
          },
        }}
      >
        {(t) => (
          <ToastBar toast={t} style={{ wordBreak: "break-word" }}>
            {({ icon, message }) => (
              <>
                {icon}
                {t.type === "error" && (
                  <button
                    className="react-hot-toast-btn"
                    onClick={() => copyToClipboard(message)}
                    style={{ marginLeft: "0.3em" }}
                  >
                    <FaCopy />
                  </button>
                )}
                {truncateMessage(message)}
                {t.type !== "loading" && (
                  <button
                    className="react-hot-toast-btn"
                    onClick={() => {
                      toast.dismiss(t.id);
                    }}
                  >
                    <HiX />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
}

export default DismissibleToast;
